import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';

import { environment } from '@environments/environment';
import { IUiState } from '@shared/types';
import { ICompanyPreferences } from '@shared/types/company/company-preferences.type';
import { IEventState } from '@shared/types/event';
import { IFilterState } from '@shared/types/filters';
import { IReportState } from '@shared/types/report';
import { IUserSession } from '@shared/types/session';
import { IConfigurableSitesState, ISiteState } from '@shared/types/site';

import { companyReducer } from './company.reducer';
import { configurableSitesReducer } from './configurable-sites.reducer';
import { eventsReducer } from './events.reducer';
import { filtersReducer } from './filters.reducer';
import { reportsReducer } from './reports.reducer';
import { selectReducer } from './select.reducer';
import { sessionReducer } from './session.reducer';
import { sitesReducer } from './sites.reducer';
import { uiReducer } from './ui.reducer';

export interface State {
    session: IUserSession;
    ui: IUiState;
    reports: IReportState;
    sites: ISiteState;
    configurableSites: IConfigurableSitesState;
    filters: IFilterState;
    company: ICompanyPreferences;
    events: IEventState;
    select: any;
}

export const reducers: ActionReducerMap<State> = {
    session: sessionReducer,
    ui: uiReducer,
    reports: reportsReducer,
    sites: sitesReducer,
    filters: filtersReducer,
    company: companyReducer,
    events: eventsReducer,
    select: selectReducer,
    configurableSites: configurableSitesReducer,
};

export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        console.log('state', state);
        console.log('action', action);

        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<State>[] = !environment.production ? [debug] : [];
